export const BACKEND_URL = "https://airsig.uil.co.nz"



// WEBPACK FOOTER //
// src/config.js